// ====================================================
// Formatiranje cene
function formatMoney(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

// ====================================================
// VIP price renderer za pojedinačan item
function renderVipPrice(originalPrice) {
  const fm = typeof formatMoney === "function"
    ? formatMoney
    : (c => (c / 100).toFixed(2));

  const vip = window.vipDiscount;

  if (!vip?.enabled) {
    return `<p class="text-sm">${fm(originalPrice)}</p>`;
  }

  const rate = vip.rate || vip.discountRate || 0;
  const discounted = Math.round(originalPrice * (1 - rate));

  return `
    <div class="flex flex-col items-end">
      <p class="text-sm">${fm(discounted)}</p>
      <p class="text-xs line-through opacity-60">${fm(originalPrice)}</p>
    </div>
  `;
}

// ====================================================
// VIP SUBTOTAL – radi sa TVOJOM HTML STRUKTUROM
function updateVipSubtotal(cart) {
  const vip = window.vipDiscount;
  const rate = vip?.rate || vip?.discountRate || 0;

  // non-VIP → regular subtotal
  if (!vip?.enabled || !rate) {
    const reg = document.querySelector(".js-subtotal");
    if (reg && cart) {
      reg.style.display = "";
      reg.textContent = formatMoney(cart.total_price);
    }
    return;
  }

  let origTotal = 0;
  let newTotal  = 0;

  cart.items.forEach(item => {
    const price = item.original_price || item.price;
    const qty   = item.quantity;
    const discounted = Math.round(price * (1 - rate));
    origTotal += price * qty;
    newTotal  += discounted * qty;
  });

  const reg = document.querySelector(".js-subtotal");
  if (reg) reg.style.display = "none";

  const vipNew = document.querySelector(".js-mini-cart-total");
  if (vipNew) vipNew.textContent = formatMoney(newTotal);

  const vipOld = document.querySelector(".js-mini-cart-old-total");
  if (vipOld) vipOld.textContent = formatMoney(origTotal);
}

// ====================================================
// Mini-cart main (Barba-safe)
(function () {
  // init only once
  if (window.__maveraMiniCartInited) return;
  window.__maveraMiniCartInited = true;

  // Cache stable elements (drawer is in header/footer → persists across Barba)
  const drawer = document.getElementById("drawer");
  if (!drawer) return;

  const list = drawer.querySelector('ul[role="list"]');
  const subtotalEl = drawer.querySelector(".js-subtotal");

  // View Basket link inside drawer -> close drawer then navigate
  drawer.addEventListener("click", (e) => {
    const link = e.target.closest("a.js-view-basket");
    if (!link) return;

    const href = link.getAttribute("href") || "/cart";

    // preseci default da mi kontrolišemo redosled (zatvori -> idi)
    e.preventDefault();
    e.stopPropagation();

    // zatvori drawer (dialog)
    try { drawer.close(); } catch (err) {
      // fallback ako nije <dialog> iz nekog razloga
      drawer.classList.add("hidden");
    }

    // idi na cart (Barba ako postoji, inače normalno)
    if (window.barba) window.barba.go(href);
    else window.location.href = href;
  });


  // --------------------------------------------
  // Update badge u navu
  function updateNavCartCount(count) {
    const navCart = document.querySelector(".js-nav-cart sup");

    if (count > 0) {
      if (navCart) {
        navCart.textContent = `(${count})`;
      } else {
        const parent = document.querySelector(".js-nav-cart");
        if (!parent) return;
        const sup = document.createElement("sup");
        sup.className = "w-5 h-5 !mx-0 !my-2 z-10";
        sup.textContent = `(${count})`;
        parent.appendChild(sup);
      }
    } else {
      if (navCart) navCart.remove();
    }
  }

  // --------------------------------------------
  // Render sidecart iz /cart.js
  async function updateCartDrawer() {
    const res = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
    const cart = await res.json();

    updateNavCartCount(cart.item_count);

    // update "View Basket (X)" link text (Liquid snapshot -> needs JS)
    const viewBasketLink = drawer.querySelector('a[href="/cart"]');
    if (viewBasketLink) {
      viewBasketLink.textContent = `View Basket (${cart.item_count})`;
    }
    const countEls = document.querySelectorAll('.js-cart-count');
countEls.forEach(el => { el.textContent = String(cart.item_count); });

    if (list) list.innerHTML = "";

    cart.items.forEach(item => {
      const price = item.original_price || item.price;
      const qty   = item.quantity;

      const li = document.createElement("li");
      li.className = "flex py-3 js-mini-cart-item border-b !border-primary";
      li.dataset.price = price;
      li.dataset.qty = qty;

      li.innerHTML = `
        <div class="w-26 h-auto shrink-0 overflow-hidden">
          <a class="text-sm uppercase leading-tight" href="${item.url}">
            <img src="${item.image.replace(/(\.[^/.]+$)/, '_200x$1')}"
                 alt="${item.title}"
                 class="w-full h-auto object-cover aspect-[0.85] !border border-primary">
          </a>
        </div>

        <div class="!ml-6 flex flex-col justify-center">
          <div class="">
            <h3 class="leading-none">
              <a class="text-sm" href="${item.url}">${item.product_title}</a>
            </h3>
          </div>

          <div class="items-en text-sm">
            Quantity:
            <span class="" data-available="${item.inventory_quantity}">
              <span class="js-quantity-num">${qty}</span>
            </span>
          </div>

          <div class="flex">
            <button
              type="button"
              class="js-remove-item !text-sm opacity-50 cursor-pointer"
              data-item-id="${item.variant_id}"
            >
              Remove
            </button>
          </div>
        </div>
      `;

      if (list) list.appendChild(li);
    });

    // regular subtotal fallback
    if (subtotalEl) {
      subtotalEl.style.display = "";
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    // VIP override
    updateVipSubtotal(cart);
  }

  // --------------------------------------------
  async function openSideCart() {
    await updateCartDrawer();
    // <dialog> native
    if (typeof drawer.showModal === "function") drawer.showModal();
  }

  // --------------------------------------------
  // ADD TO CART (delegated) — radi posle Barba navigacije
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".js-add-to-cart");
    if (!btn) return;

    e.preventDefault();

    const form = btn.closest("form");
    if (!form) return;

    const originalText = btn.textContent;
    btn.textContent = "Adding...";
    btn.disabled = true;
    btn.classList.add("opacity-60", "cursor-not-allowed");

    const formData = new FormData(form);

    try {
      await fetch("/cart/add.js", { method: "POST", body: formData });
      await openSideCart();
    } catch (error) {
      console.error("Greška pri dodavanju u korpu:", error);
    } finally {
      btn.textContent = originalText;
      btn.disabled = false;
      btn.classList.remove("opacity-60", "cursor-not-allowed");
    }
  });

  // --------------------------------------------
  // Dugme iz nava (otvara sidecart) — delegated (header može da se menja klasama)
  document.addEventListener("click", async (e) => {
    const navCartBtn = e.target.closest(".js-open-cart");
    if (!navCartBtn) return;

    e.preventDefault();
    await openSideCart();
  });

  // --------------------------------------------
  // Remove u sidecartu (drawer persistira, može direktno)
  drawer.addEventListener("click", async (e) => {
    const rm = e.target.closest(".js-remove-item");
    if (!rm) return;

    const variantId = rm.dataset.itemId;

    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: { [variantId]: 0 } })
    });

    await updateCartDrawer();

    if (window.location.pathname === "/cart") {
      window.location.reload();
    }
  });

  // --------------------------------------------
  // Promena količine (+/-) (ako stvarno koristiš .js-qty-change u draweru)
  drawer.addEventListener("click", async (e) => {
    const btn = e.target.closest(".js-qty-change");
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    const change = parseInt(btn.dataset.change, 10);

    const qtySpan = btn.parentElement.querySelector(".js-quantity-num");
    const currentQty = parseInt(qtySpan.textContent, 10);
    const newQty = Math.max(currentQty + change, 0);

    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: { [variantId]: newQty } })
    });

    await updateCartDrawer();

    if (window.location.pathname === "/cart") {
      window.location.reload();
    }
  });

  // --------------------------------------------
  // Custom event (ako ga koristiš negde)
  drawer.addEventListener("dialog:open", updateCartDrawer);

  // Optional: expose refresh helper for other scripts
  window.maveraMiniCartRefresh = updateCartDrawer;
})();
